module.exports = __webpack_public_path__ + "static/img/brand2.ded3249.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/分类/brand2.png
// module id = A4Ic
// module chunks = 192